<template>
  <div class="train">
    <!-- <div class="banner">
      <img src="../../assets/banner.png" alt="" />
    </div> -->
    <div class="train_content container">
      <div class="video_type">
        <div class="train_title">
          <span class="iconfont iconleixing"></span>培训分类
        </div>
        <div class="type_list">
          <div :class="['type_item', { type_item_active: item.id == itemidflag }]" v-for="item in videotypelist" :key="item.id" @click="typeclick(item.id)">
              {{ item.typeName }}
          </div>
        </div>
      </div>
      <div class="train_list">
        <el-row :gutter="10">
          <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" v-for="item in videoList" :key="item.id">
            <div class="train_item" @click="videoclick(item.id)">
              <div class="video_box">
                <img :src="baseurl + item.videoImg" alt="">
                <div class="box_shade">
                  <span class="iconfont iconkaishi"></span>
                </div>
              </div>
            </div>    
          </el-col>
        </el-row>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :current-page="dataForm.page"
          @current-change="handleCurrentChange"
          @prev-click="getvideoList"
          @next-click="getvideoList"
          >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "train",
  data () {
    return {
      dataForm: {
        page: 1,
        limit: 12,
        video_type: ''
      },
      total: 0,
      videotypelist: [],
      videoList: [],
      itemidflag: '',
      baseurl: this.$baseurl
    }
  },
  mounted() {
    this.gettypeList();
    this.getvideoList()
  },
  methods: {
    handleCurrentChange(v) {
      this.dataForm.page = v
      this.getvideoList()
    },
    gettypeList() {
      this.$http.get("/video/videotype/selectAll").then(res => {
        if (res.data.code == 0) {
          this.videotypelist = res.data.data;
        }
      });
    },
    async getvideoList() {
      let { data: { data, code }} = await this.$http.get('/video/page', { params: this.dataForm})
      if(code != 0) return 
      console.log(data.list);
      this.videoList = data.list
      this.total = data.total
    },
    typeclick(i) {
       if(i == this.itemidflag) {
        this.itemidflag = ''
         this.dataForm.video_type = ''
      } else {
        this.itemidflag = i
         this.dataForm.video_type = i
      }  
      this.dataForm.page = 1
      this.getvideoList()
    },
    videoclick(id) {
      console.log(id);
      this.$router.push({ path: '/trainDetail', query: { id }})
    }
  }
};
</script>

<style lang="scss" scoped>
.train {
  .pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0 30px 0;
    }
  .banner {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .train_content {
    .video_type {
      .train_title {
        font-size: 24px;
        line-height: 2;
        .iconleixing {
          font-size: 28px;
          color: #3498db;
          margin-right: 5px;
        }
      }
        .type_list {
        .type_item {
          cursor: pointer;
          display: inline-block;
          border: 2px solid rgba($color: #3498db, $alpha: 1);
          padding: 5px 15px;
          margin: 5px;
          background: rgba($color: #2980b9, $alpha: 1);
          color: #fff;
        }
        .type_item_active {
          border: 2px solid rgba($color: #de010e, $alpha: .6);
          background-color: #de010e;
          color: #fff;
        }    
      }    
    }
     .train_list {
       padding: 20px 0;
        .train_item {
          width: 100%;
          margin-bottom: 10px;
          border-radius: 3px;
          overflow: hidden;
          cursor: pointer;
          .video_box {
            position: relative;
            width: 100%;
            height: 215px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .box_shade {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: rgba($color: #000000, $alpha: .3);
              transition: all .3s;
              .iconkaishi {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: #fff;
                font-size: 58px;
              }
              &:hover {
                transform: scale(1.5);
              }
            }
          }
        }
      }
  }
}
</style>